// src/authHelpers.js
export const matiereToSlug = (matiere) => {
  const map = {
    // 2Bac
    "SVT": "svt",
    "Physique-Chimie": "pc",
    "Mathématiques": "math",
    "Philosophie": "philo",
    "Anglais": "ang",
    // 3AC Fr
    "Éducation islamique": "ei",
    "Education islamique": "ei", // fallback sans accent
    "EI": "ei",
    "Histoire-Géographie": "hg",
    "Histoire - Géographie": "hg",
    "HG": "hg",
    "Arabe": "ar",
    "Français": "fr",
    "FR": "fr",
  };
  return map[matiere] || "svt";
};
